import { render } from "./OrthoProgressBar.vue?vue&type=template&id=6ce44ef6"
import script from "./OrthoProgressBar.vue?vue&type=script&lang=js"
export * from "./OrthoProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__